import { MtnaDataType } from '@mtna/data-core-ts';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { RdsFilterType } from '../models/filter/filter-type.model';
import { RdsDataTypeUtil } from './data-type-util';

export class RdsFilterUtil {
  /**
   * Given a variable, determine the appropraite filter type
   * @param variable Variable to determine the filter type
   * @returns the filter type for the given variable
   */
  static determineType<V extends Variable | VariableSummary = Variable>(variable: V | undefined | null): RdsFilterType | null {
    if (!variable) {
      return null;
    }

    const hasClassification = !!variable.classificationUri || !!(variable as VariableSummary).classificationId;
    if (hasClassification) {
      return 'CODE';
    }

    if (variable.dataType === 'DATE') {
      return 'DATE';
    }

    if (RdsDataTypeUtil.simplifyMtnaDataType(variable.dataType as MtnaDataType) === 'TEXT') {
      return 'TEXT';
    }

    if (RdsDataTypeUtil.simplifyMtnaDataType(variable.dataType as MtnaDataType) === 'NUMERIC') {
      return 'NUMERIC';
    }

    console.warn(`[@rds/components][RdsFilterUtil] - could not determine type of `, variable);
    return null;
  }
}
